import * as React from 'react';

import { useFilterContext } from '../../contexts/FiltersContext';
import { BaseSelectionFilter } from '../../models/Filter';
import BaseFilterChip from './BaseFilterChip';

type MakeFilterChipProps = {
  filter: BaseSelectionFilter;
  value: string;
};

const SelectionFilterChip = ({ filter, value }: MakeFilterChipProps) => {
  const { persistState, handleRemoveFilter } = useFilterContext();

  return (
    <BaseFilterChip
      filter={filter}
      onRemove={() => {
        filter.removeFn(value);
        if (filter.values.length === 0) {
          handleRemoveFilter(filter);
        } else {
          persistState();
        }
      }}
      text={value}
    />
  );
};

export default SelectionFilterChip;
